<template>
  <div>
    <h3 class="is-size-5 has-text-weight-medium has-text-centered">
      {{ $t('resourceNotificationsCreateModal.preview.title') }}
    </h3>

    <div class="mt-2 resource-notification-preview-frame">
      <img src="~/assets/images/device-frame.png" />

      <div class="resource-notification-preview-content-mask">
        <div class="resource-notification-preview-content is-size-7 is-unselectable">
          <h4 class="has-text-weight-bold is-size-6">
            {{ resourceNotification.title }}
          </h4>
          <p class="mt-1">
            {{ resource.advertorial.issue.name }} - {{ resource.advertorial.issue.country }}
          </p>
    
          <auth-image
            :src="firstImage.url_thumb || firstImage.url"
            class="mt-2"
            borders
          />

          <text-editor
            v-if="resourceFullText"
            :value="resourceFullText"
            :highlight-words="[]"
            model-id="full_text_body"
            class="mt-1 resource-full-text-preview"
            placeholder=""
            read-only
          />
          <span
            v-if="resourceFullText"
            class="is-underlined has-text-link"
          >
            {{ $t('resourceNotificationsCreateModal.preview.read_more') }}
          </span>
    
          <p
            v-if="otherImages.length > 0"
            class="mt-2 has-text-weight-bold"
          >
            {{ $t('resourceNotificationsCreateModal.preview.other_images') }}
          </p>
          <div
            v-if="otherImages.length > 0"
            class="columns is-variable is-2 is-multiline"
          >
            <div
              v-for="image in otherImages"
              :key="image.id"
              class="column is-half"
            >
              <auth-image
                :src="image.url_thumb || image.url"
                borders
              />
            </div>
          </div>
    
          <p
            v-if="visibleMetadataFields"
            class="mt-2 has-text-weight-bold"
          >
            {{ $t('resourceNotificationsCreateModal.preview.metadata_title') }}
          </p>
          <table
            v-if="visibleMetadataFields"
            class="table is-fullwidth is-borderless is-narrow"
          >
            <tr
              v-for="(values, key) in visibleMetadataFields"
              :key="key"
              class="metadatum-row has-border-bottom"
            >
              <td>
                <strong>{{ $t(`resourceForm.labels.metadatum.${key}`) }}</strong>
              </td>
              <td>
                {{ [values].flat().join(', ') }}
              </td>
            </tr>
          </table>

          <div
            v-if="resourceWebsiteLinks.length > 0"
            class="mt-2 is-flex"
          >
            <span
              v-for="(link, idx) in resourceWebsiteLinks"
              :key="link"
              class="is-underlined has-text-link ml-1"
            >
              <span class="icon is-small">
                <fa-icon :icon="['fas', 'external-link-alt']" />
              </span>
              <span>
                {{ $t('advancedSearchShowModal.openOriginalArticleButton', { page: idx + 1 }) }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { resourceFullText, visibleMetadataFields, resourceImages } from './utils'

const TextEditor = () => import('@/components/ResourceForm/TextEditor.vue')
const AuthImage = () => import('@/components/commons/AuthImage/Single.vue')

export default {
  name: 'ResourceNotificationsCreatePreview',
  components: { AuthImage, TextEditor },
  props: {
    resourceNotification: {
      type: Object,
      required: true
    },
    resource: {
      type: Object,
      required: true
    }
  },
  computed: {
    firstImage() {
      const mediumId = this.resourceNotification.medium_ids[0]
      if (!mediumId) { return {} }

      return resourceImages(this.resource).find(({ id }) => id === mediumId)
    },
    otherImages() {
      return resourceImages(this.resource).filter(({ id }) => (
        this.resourceNotification.medium_ids.includes(id) && id !== this.firstImage.id
      ))
    },
    resourceFullText() {
      if (this.resourceNotification.include_text) {
        return resourceFullText(this.resource)
      }
      
      return undefined
    },
    visibleMetadataFields() {
      if (this.resourceNotification.include_metadata) {
        return visibleMetadataFields(this.resource)
      }

      return undefined
    },
    resourceWebsiteLinks() {
      if (this.resource.type !== 'website') { return [] }

      return this.resource.advertorial.pages.map(page => page.page_url)
    }
  }
}
</script>
<style lang="scss">
.resource-notification-preview-frame {
  margin: 0 auto;
  width: 60%;
  position: sticky;
  top: 20px;
}

.resource-notification-preview-content-mask {
  position: absolute;
  padding-top: 18%;
  padding-bottom: 12%;
  padding-right: 15px;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}

.resource-notification-preview-content {
  width: 100%;
  height: 100%;
  overflow: scroll;
  padding-right: 15px;
  padding-left: 30px;
}

.resource-full-text-preview {
  max-height: 300px;
  overflow: hidden;

  & .ql-editor {
    color: $grey-dark;
  }
}

.metadatum-row:last-of-type {
  border-bottom: none;
}
</style>
